import React from 'react';
import { AppVersion } from '../types';
import { Clock } from 'lucide-react';

interface VersionHistoryProps {
  versions: AppVersion[];
  averageUpdateDays: number;
}

export const VersionHistorySection: React.FC<VersionHistoryProps> = ({
  versions = [],
  averageUpdateDays = 14
}) => {
  const safeVersions = Array.isArray(versions) ? versions : [];

  return (
    <div className="bg-white rounded-3xl p-6 border border-slate-200/80 shadow-sm space-y-5">
      <div className="flex flex-col sm:flex-row sm:items-center justify-between gap-2 pb-4 border-b border-slate-100">
        <div>
          <span className="text-xs font-semibold uppercase tracking-wider text-slate-400">Release Cadence</span>
          <h3 className="text-lg font-bold text-slate-900 tracking-tight">Version History & Velocity</h3>
        </div>
        <div className="flex items-center gap-1.5 bg-blue-50 text-blue-800 px-3 py-1.5 rounded-xl border border-blue-100 text-xs font-semibold">
          <Clock className="w-3.5 h-3.5 text-blue-700" strokeWidth={2} />
          <span>Average update cadence:</span>
          <strong className="text-blue-900">{averageUpdateDays} days</strong>
        </div>
      </div>

      <div className="space-y-4">
        {safeVersions.length === 0 ? (
          <div className="p-6 text-center text-xs text-slate-500 font-medium bg-slate-50/60 rounded-2xl border border-slate-100">
            No version history records available
          </div>
        ) : (
          safeVersions.map((ver, idx) => (
          <div
            key={ver.version || idx}
            className="p-4 rounded-2xl bg-slate-50/80 border border-slate-100 hover:border-slate-200 transition-all"
          >
            <div className="flex items-center justify-between gap-2 mb-1.5">
              <div className="flex items-center gap-2">
                <span className="font-bold text-slate-900 text-sm">Version {ver.version || '1.0'}</span>
                {idx === 0 && (
                  <span className="text-[10px] bg-emerald-100 text-emerald-800 font-bold px-2 py-0.5 rounded-full">
                    Latest
                  </span>
                )}
              </div>
              <span className="text-xs text-slate-500 font-medium">{ver.releaseDate || 'Recent'}</span>
            </div>

            <p className="text-xs text-slate-600 leading-relaxed">
              {ver.releaseNotes || 'Maintenance update and bug fixes.'}
            </p>
          </div>
        ))
        )}
      </div>
    </div>
  );
};
